import React, { useState } from "react";
import "./AddRoleForm.css"; // Ensure proper styling

const AddRoleForm = ({ onClose, onRoleAdded }) => {
  const [formData, setFormData] = useState({
    role_name: "",
    description: ""
  });

  const [error, setError] = useState(null);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.role_name) {
      setError("Role name are required.");
      return;
    }

    try {
      const response = await fetch("/api/roles/add-role", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to add Role.");
      }

      alert("✅ Role added successfully!");
      setTimeout(() => {
        onRoleAdded(); // Refresh user list
        onClose(); // Close modal
      }, 300);
    } catch (error) {
      console.error("❌ Error adding Role:", error.message);
      setError(error.message || "An error occurred.");
    }
  };

  return (
    /** ✅ Wrap everything in a <div> to avoid ESLint error */
    <div className="modal-overlay">
      <div className="modal-content">
        {/* Close Button */}
        <button className="close-button" onClick={onClose}>✖</button>

        <h3>Add Role</h3>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label id="add-user-label">Role Name:</label>
            <input id="add-user-input" type="text" name="role_name" value={formData.role_name} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label id="add-user-label">Description:</label>
            <input id="add-user-input" type="text" name="description" value={formData.description} onChange={handleChange} />
          </div>         
            {/* Display error message */}
          {error && <p className="error-message">{error}</p>}

          <button type="submit" className="submit-btn">Add Role</button>
        </form>
      </div>
    </div>
  );
};

export default AddRoleForm;
